import { FC } from 'react';

import { Product } from '@/entities/product';
import styles from '@/entities/product/ui/card/card.module.scss';
import { useCartStore } from '@/features/cart';
import { CounterSimple } from '@/features/counter';
import { Icon } from '@/shared/ui';

interface AddToCartProps {
  product: Product;
  selectedPrice: number;
}

const AddToCart: FC<AddToCartProps> = (props) => {
  const { product, selectedPrice } = props;
  const { addToCart, items, adjustQuantity } = useCartStore();

  const cartItem = items.find(
    (item) =>
      item.product.id === product.id && item.selectedPrice.id === selectedPrice,
  );

  function handleAddToCart() {
    addToCart(product, selectedPrice);
  }

  function handleIncrement() {
    if (cartItem) {
      adjustQuantity(product.id, selectedPrice, 1);
    }
  }

  function handleDecrement() {
    if (cartItem) {
      adjustQuantity(product.id, selectedPrice, -1);
    }
  }

  if (cartItem && cartItem.quantity > 0) {
    return (
      <CounterSimple
        count={cartItem.quantity}
        decrement={handleDecrement}
        increment={handleIncrement}
      />
    );
  }

  return (
    <button className={styles.card__add_to_cart} onClick={handleAddToCart}>
      В корзину
      <Icon className={styles.card__add_to_cart_icon} name="plusBig" />
    </button>
  );
};
export default AddToCart;
